(() => {
  const ROOT_SELECTOR = '[data-pm-faq]';
  const TRIGGER_SELECTOR = '[data-pm-faq-trigger]';
  const controllers = new WeakMap();

  function setState(root, trigger, open) {
    const item = trigger.closest('[data-pm-faq-item]');
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
    if (!item || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
  }

  function closeOthers(root, current) {
    root.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      if (trigger !== current && trigger.getAttribute('aria-expanded') === 'true') {
        setState(root, trigger, false);
      }
    });
  }

  function focusByKey(triggers, currentIndex, key) {
    let nextIndex = currentIndex;
    if (key === 'ArrowDown') nextIndex = (currentIndex + 1) % triggers.length;
    if (key === 'ArrowUp') nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
    if (key === 'Home') nextIndex = 0;
    if (key === 'End') nextIndex = triggers.length - 1;
    if (nextIndex !== currentIndex) triggers[nextIndex].focus();
  }

  function init(root) {
    if (!root || root.dataset.pmFaqReady === 'true') return;
    root.dataset.pmFaqReady = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    controllers.set(root, controller);

    const triggers = [...root.querySelectorAll(TRIGGER_SELECTOR)];
    triggers.forEach((trigger, index) => {
      setState(root, trigger, false);

      trigger.addEventListener('click', () => {
        const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
        if (root.dataset.pmFaqBehavior !== 'independent') closeOthers(root, trigger);
        setState(root, trigger, shouldOpen);
      }, { signal });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          if (!event.repeat) trigger.click();
          return;
        }

        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        focusByKey(triggers, index, event.key);
      }, { signal });
    });
  }

  function rootsWithin(scope = document) {
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    return roots;
  }

  function initAll(scope = document) {
    rootsWithin(scope).forEach(init);
  }

  function destroy(root) {
    controllers.get(root)?.abort();
    controllers.delete(root);
    delete root.dataset.pmFaqReady;
  }

  function destroyAll(scope) {
    rootsWithin(scope).forEach(destroy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));
})();
